import { SnapshotConfig } from "@sg-protect/core";
import config from "@sg-protect/runtime-config";
import { workspacePaths } from "../paths.ts";

export function shuffleArray<T>(array: T[]): T[] {
    if (SnapshotConfig.deterministic) {
        return [...array];
    }

    const copy = [...array];

    for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }

    return copy;
}

export const MAX_STORAGE_QUOTA_BYTES = 27_487_790_694_400; // 25 TiB

export function base64UrlEncode(obj: Record<string, string>) {
    const bytes = new TextEncoder().encode(JSON.stringify(obj));
    let binary = "";
    for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
    }

    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function isStringRecord(value: unknown): value is Record<string, string> {
    return (
        typeof value === "object" &&
        value !== null &&
        !Array.isArray(value) &&
        Object.values(value).every(entry => typeof entry === "string")
    );
}

export function base64UrlDecode(str: string): Record<string, string | undefined> {
    try {
        const base64 = str.replace(/-/g, "+").replace(/_/g, "/") + "===".slice((str.length + 3) % 4);
        const binary = atob(base64);
        const bytes = new Uint8Array(binary.length);

        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }

        const json = new TextDecoder().decode(bytes);
        const parsed: unknown = JSON.parse(json);

        return isStringRecord(parsed) ? parsed : {};
    } catch {
        return {};
    }
}

export function buildRemediationAdminConsentUrl(tenantId: string, returnUrl: string) {
    const { microsoft, app_registrations: appRegistrations } = config.get();
    const query = new URLSearchParams({
        client_id: appRegistrations.remediation,
        state: base64UrlEncode({ intent: "remediation_consent", redirectUri: returnUrl }),
        redirect_uri: `${window.location.origin}${workspacePaths.remediationPostConsent}`
    });

    return `${microsoft.adminConsentBase}/${tenantId}/adminconsent?${query}`;
}
